import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ICONS } from "../../constants/icons"
import { isCityAdminUser } from "../../helpers/cityPortalRoles"
import { useSelector } from "react-redux"
import useAdminPermission from "../../hooks/useAdminPermission"
import AdminCityDropdown from "./AdminCityDropdown"
import AdminNotificationDropdown from "./AdminNotificationDropdown"
import { toggleAdminSidebar } from "./sidebarToggle"

const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const currentUser = useSelector(state => state.auth.currentUser)
  const isCityAdmin = isCityAdminUser(currentUser)
  const { can, isReady, isSuperAdmin } = useAdminPermission()
  const canViewActivityLogs =
    isSuperAdmin || (isReady && can("activity-logs", "view"))

  const isActivityLogActive = location.pathname.startsWith(
    "/admin/activity-log",
  )

  return (
    <header className="admin-header">
      <div className="admin-header__inner">
        <button
          type="button"
          className="admin-header__menu-btn"
          onClick={toggleAdminSidebar}
          aria-label="Toggle sidebar"
        >
          <img src={ICONS.adminGrid4} alt="" />
        </button>

        <div className="admin-header__actions">
          <AdminNotificationDropdown />
          {canViewActivityLogs ? (
            <button
              type="button"
              className={`admin-header__icon-btn${
                isActivityLogActive ? " admin-header__icon-btn--active" : ""
              }`}
              aria-label="Activity Log"
              onClick={() => navigate("/admin/activity-log")}
            >
              <img src={ICONS.adminActivityLog} alt="" />
            </button>
          ) : null}
          {isCityAdmin ? <AdminCityDropdown /> : null}
        </div>
      </div>
    </header>
  )
}

export default Header
